module.exports = "<div class=\"dialog-content-container\">\n  <img [src]=\"data.src\"/>\n</div>\n"